import React from 'react';
import { Link } from 'react-router-dom';

import { Button, Card, Heading, PageContainer, Section } from '../../../shared/ui';

const resolveButtonComponent = (action) => {
  if (!action?.href) {
    return 'button';
  }
  return action.href.startsWith('/') ? Link : 'a';
};

const ActionSection = ({ title, lead, actions = [] }) => {
  return (
    <Section surface="panel">
      <PageContainer>
        <Card className="yowan-action-section">
          <Heading as="h2">{title}</Heading>
          <p>{lead}</p>
          <div className="u-inline-links">
            {actions.map((action) => (
              <Button
                key={`${action.label}-${action.href}`}
                as={resolveButtonComponent(action)}
                {...(action.href.startsWith('/') ? { to: action.href } : { href: action.href })}
                variant={action.variant || 'primary'}
              >
                {action.label}
              </Button>
            ))}
          </div>
        </Card>
      </PageContainer>
    </Section>
  );
};

export default ActionSection;
